import type { Locale } from "../Locale.js";

export function getNewsAnchor(locale: Locale): string {
	return { cs: "#novinky", en: "#news" }[locale];
}
